<template>
  <v-container grid-list-xl>
    <h2 class="display-1">Neues Prüfungsset</h2>
    <v-flex>
      <EditSetComponent
        :set="set"
        :verfahren="verfahren"
        :arten="arten"
        :sektoren="sektoren"
        @onSave="saveSet"
      />
    </v-flex>
  </v-container>
</template>

<script>
import EditSetComponent from './EditSetComponent';

export default {
  name: 'CreateSetPage',
  data() {
    return {
      isLoading: true,
      arten: [],
      sektoren: [],
      verfahren: [],
      set: {}
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        this.isLoading = true;

        const [verfahren, arten, sektoren] = await Promise.all([
          this.$http.get('verfahren'),
          this.$http.get('produktart'),
          this.$http.get('industriesektor')
        ]);

        this.set = {
          ID: 0,
          Bezeichnung: '',
          Verfahren: '',
          produktarten: [],
          industriesektoren: []
        };

        this.verfahren = verfahren.body;
        this.arten = arten.body;
        this.sektoren = sektoren.body;
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    saveSet(set) {
      this.$http
        .post(`pruefungsset`, set)
        .then(resp => {
          this.$router.push({ name: 'SingleSet', params: { setId: resp } });
        })
        .catch(err => console.error(err));
    }
  },
  components: {
    EditSetComponent
  }
};
</script>
